import {
	ChangeDetectionStrategy,
	Component,
	computed,
	EventEmitter,
	Input,
	Output,
	signal
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ResponsiveLayoutService } from '@go-modules/services/responsive-layout/responsive-layout.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { DisabledInteractiveDirective } from '@go-modules/directives/disabled-interactive/disabled-interactive.directive';

@Component({
	selector: 'task-list-navigator',
	templateUrl: './task-list-navigator.component.html',
	styleUrls: ['./task-list-navigator.component.scss'],
	standalone: true,
	imports: [
		TranslateModule,
		MatIconModule,
		DisabledInteractiveDirective
	],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskListNavigatorComponent {
	@Input()
	public set totalTasks (value: number) {
		this.totalTasksSignal.set(value);
	}

	public get totalTasks (): number {
		return this.totalTasksSignal();
	}

	@Input()
	public set currentTaskIndex (value: number) {
		this.currentTaskIndexSignal.set(value);
	}

	public get currentTaskIndex (): number {
		return this.currentTaskIndexSignal();
	}

	@Input() public isComplete = false;
	@Input() public previousButtonLabelKey = 'task-details_nav-back';
	@Output() public navigateBack = new EventEmitter<void>();
	@Output() public navigateForward = new EventEmitter<void>();
	@Output() public openNavigator = new EventEmitter<void>();
	public readonly isMobile$ = this.responsiveLayoutService.isMobileSize$;
	private readonly totalTasksSignal = signal(0);
	private readonly currentTaskIndexSignal = signal(0);
	private readonly isMobile = toSignal(this.isMobile$, { initialValue: false });
	public readonly shouldShowNavigator = computed(() =>
		this.totalTasksSignal() > 0 && this.isMobile()
	);
	public readonly canGoBack = computed(() =>
		this.currentTaskIndexSignal() > 1
	);
	public readonly canGoForward = computed(() =>
		this.currentTaskIndexSignal() < this.totalTasksSignal()
	);

	constructor (
		private readonly responsiveLayoutService: ResponsiveLayoutService
	) {}

	public onNavigateBack (): void {
		if (!this.canGoBack()) {
			return;
		}

		this.navigateBack.emit();
	}

	public onNavigateForward (): void {
		if (!this.canGoForward()) {
			return;
		}

		this.navigateForward.emit();
	}
}
